<template lang="pug">
    include Welcome.pug
</template>

<script>
import PrivateRouterLink from '@/directives/PrivateRouterLink'

export default {
  name: 'Welcome',
  components: { PrivateRouterLink },
  data() {
    // Data contained on the component
    return {
      editMenu: false,
    }
  },
  created() {},
  methods: {
    toggleEditMenu() {
      this.editMenu = !this.editMenu
    },
  },
}
</script>

<style scoped lang="scss">
@import './../variables';
@import 'dashboard/Dashboard';
@import 'Welcome';
</style>



// WEBPACK FOOTER //
// src/components/Welcome.vue